module.exports = __webpack_public_path__ + "img/logo.8f77cea9.jpg";